import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  // public baseURL: string = 'http://localhost:4000/';
  public baseURL: string = 'https://api.eplogoffplan.com/';
  public urls: any = {
    auth: {
      login: 'auth/login',
    },
    fileUpload: {
      fileUrl: 'users/uploadFile',
      delete: 'users/deleteFile'
    },
    users: {
      getAllUsers: 'users/getAllUsers',
      getUserById: 'users/getUserById?id=',
      updateUser: 'users/updateUser',
      createUser: 'users/createUser',
      createContact: 'users/createContact',
      getContacts: 'users/getContacts'
    },
    roles: {
      getRoles: 'roles/getRoles',
      createRole: 'roles/createRole',
      updateRole: 'roles/updateRole',
      updateRoleByStatus: 'roles/updateRoleStatus'
    },
    country: {
      getCountries: 'countries/getCountries',
      createCountry: 'countries/createCountry',
      updateCountry: 'countries/updateCountry',
      updateCountryStatus: 'countries/updateCountryStatus'
    }, states: {
      getStates: 'states/getLightStates',
      createState: 'states/createState',
      updateState: 'states/updateState',
      updateStateStatus: 'states/updateStateStatus',
      getStatesByCountryId: 'states/getStatesByCountryId?countryId=',
      getStatesById: 'states/getStatesById?stateId='
    }, cities: {
      getCities: 'cities/getCities',
      createCity: 'cities/createCity',
      updateCity: 'cities/updateCity',
      updateCityStatus: 'cities/updateCityStatus',
      getCitiesByStateId: 'cities/getCitiesByStateId?stateId='
    }, propertyTypes: {
      getPropertyType: 'propertyTypes/getPropertyType',
      createPropertyType: 'propertyTypes/createPropertyType',
      updatePropertyType: 'propertyTypes/updatePropertyType',
      updatePropertyTypeStatus: 'propertyTypes/updatePropertyTypeStatus'
    }
    , developers: {
      getDevelopers: 'developers/getDevelopers',
      createDeveloper: 'developers/createDeveloper',
      updateDeveloper: 'developers/updateDeveloper',
      updateDeveloperStatus: 'developers/updateDeveloperStatus',
      getDevelopersWithProjectCount: 'developers/getDevelopersWithProjectCount',
      getDeveloperById: 'developers/getDeveloperById',
    }
    , community: {
      getCommunity: 'community/getCommunity',
      createCommunity: 'community/createCommunity',
      updateCommunity: 'community/updateCommunity',
      updateCommunityStatus: 'community/updateCommunityStatus',
      getCommunityWithProjectCount: 'community/getCommunityWithProjectCount',
      getCommunityById: 'community/getCommunityById',
    }
    , feature: {
      getFeatures: 'feature/getFeatures',
      createFeature: 'feature/createFeature',
      updateFeature: 'feature/updateFeature',
      updateFeatureStatus: 'feature/updateFeatureStatus',

    }, internalExternalFeature: {
      getFeatures: 'internalExternalFeature/getFeatures',
      createFeature: 'internalExternalFeature/createFeature',
      updateFeature: 'internalExternalFeature/updateFeature',
      updateFeatureStatus: 'internalExternalFeature/updateFeatureStatus'
    }, location: {
      getLocation: 'location/getLocation',
      getAllLocation: 'location/getAllLocation',
      createLocation: 'location/createLocation',
      updateLocation: 'location/updateLocation',
      updateLocationStatus: 'location/updateLocationStatus',
      getLocationByCityId: 'location/getLocationByCityId?cityId=',
      getLocationDetails: 'location/getLocationDetails',
      getLocationById: 'location/getLocationById'
    },
    properties: {
      getProperties: 'properties/getProperties',
      getAllProperty: 'properties/getAllProperty',
      createProperty: 'properties/createProperty',
      updateProperty: 'properties/updateProperty',
      updatePropertyStatus: 'properties/updateCommunityStatus',
      getPropertyById: 'properties/getPropertyById?id='
    },
    project: {
      getProjects: 'projects/getProjects',
      getAllProjects: 'projects/getAllProjects',
      getProjectsBaseOnFilter: 'projects/getProjectsBaseOnFilter',
      getProjectsBaseOnPropertyTypeFilter: 'projects/getProjectsBaseOnPropertyTypeFilter',
      createProject: 'projects/createProject',
      updateProject: 'projects/updateProject',
      updateProjectStatus: 'projects/updateProjectStatus',
      getProjectById: 'projects/getProjectById?id=',
      getProjectByIdInDetails: 'projects/getProjectByIdInDetails',

      createProjectFeature: 'projects/createProjectFeature',
      getFeatureByProjectId: 'projects/getFeatureByProjectId?projectId=',
      createPaymentPlanSection: 'projects/createPaymentPlanSection',
      getPaymentPlanSectionByProjectId: 'projects/getPaymentPlanSectionByProjectId?projectId=',
      getPaymentPlanParentByProjectId: 'projects/getPaymentPlanParentByProjectId?projectId=',
      createPaymentPlanParentSection: 'projects/createPaymentPlanParentSection',
      deleteProjectFeature: 'projects/deleteProjectFeature',
      createProjectGallery: 'projects/createProjectGallery',
      getAllProjectGallery: 'projects/getAllProjectGallery?projectId=',
      createFeatureParentSection: 'projects/createFeatureParentSection',
      getFeatureParentByProjectId: 'projects/getFeatureParentByProjectId?projectId=',
    },
    floorPlans: {
      getFloorPlan: 'floorPlans/getFloorPlan?projectId=',
      createFloorPlan: 'floorPlans/createFloorPlan',
      updateFloorPlanItem: 'floorPlans/updateFloorPlanItem',
      updateFloorPlanStatus: 'floorPlans/updateFloorPlanStatus',
      createFloorPlanItem: 'floorPlans/createFloorPlanItem',
      deleteFloorPlanItem: 'floorPlans/deleteFloorPlan',
    },
    locationMap: {
      getLocationMap: 'locationMap/getLocationMap?projectId=',
      createLocationMap: 'locationMap/createLocationMap',
      updateLocationMap: 'locationMap/updateLocationMap',
      updateLocationMapStatus: 'locationMap/updateLocationMapStatus',
    },
    locationNearPlaces: {
      createLocationNearPlaces: 'locationNearPlaces/createLocationNearPlaces',
      updateLocationNearPlaces: 'locationNearPlaces/updateLocationNearPlaces',
    },
    masterPlans: {
      getMasterPlan: 'masterPlans/getMasterPlan?projectId=',
      createMasterPlan: 'masterPlans/createMasterPlan',
      updateMasterPlan: 'masterPlans/updateMasterPlan',
      updateMasterPlanStatus: 'masterPlans/updateMasterPlanStatus',
      deleteMasterItem: 'masterPlans/deleteMasterItem'
    },
    masterPlanItems: {
      createMasterPlanItems: 'masterPlanItems/createMasterPlanItems',
      updateMasterPlanItems: 'masterPlanItems/updateMasterPlanItems',

    },
    paymentPlan: {
      getProjectPaymentPlan: 'paymentPlan/getProjectPaymentPlan',
      createProjectPaymentPlan: 'paymentPlan/createProjectPaymentPlan',
      updateProjectPaymentPlan: 'paymentPlan/updateProjectPaymentPlan',
      updateProjectPaymentStatus: 'paymentPlan/updateProjectPaymentStatus',
      deletePaymentPlan: 'paymentPlan/deletePaymentPlan'
    },
    paymentPlanTypes: {
      getProjectPlanType: 'paymentPlanTypes/getProjectPlanType',
      createProjectPlanType: 'paymentPlanTypes/createProjectPlanType',
      updateProjectPlanType: 'paymentPlanTypes/updateProjectPlanType',
      updateProjectPlanTypeStatus: 'paymentPlanTypes/updateProjectPlanTypeStatus',
    },
    paymentPlanCriteria: {
      getProjectPaymentCriteria: 'paymentPlanCriteria/getProjectPaymentCriteria?projectId=',
      createProjectPaymentCriteria: 'paymentPlanCriteria/createProjectPaymentCriteria',
      updatePaymentCriteria: 'paymentPlanCriteria/updatePaymentCriteria',
      updatePaymentCriteriaStatus: 'paymentPlanCriteria/updatePaymentCriteriaStatus',
    },
    landingPage: {
      getProjectsBaseOnType: 'landingHome/getProjectsBaseOnType',
      getDeveloperWithProjectCount: 'landingHome/getDeveloperWithProjectCount',
      getCommunity: 'landingHome/getCommunity',
      getStateWithProjectsCount: 'landingHome/getStateWithProjectsCount',
      getLatestProject: 'landingHome/getLatestProject',
      getUpcomingProject: 'landingHome/getUpcomingProject',
      getPropertyTypeCount: 'landingHome/getPropertyTypeCount',
      getPropertyTypeCommunityCount: 'landingHome/getPropertyTypeCommunityCount'
    },
    services: {
      getService: 'services/getService',
      updateService: 'services/updateService',
      updateServiceTab: 'services/updateServiceTab',
      createServiceItem: 'services/createServiceItem',
      deleteService: 'services/deleteService',
      createServiceTabs: 'services/createServiceTabs'
    },
    newArticleCategory: {
      getNewsArticlesCategory: 'newArticleCategory/getNewsArticlesCategory',
      updateNewArticleCategory: 'newArticleCategory/updateNewArticleCategory',
      createNewArticleCategory: 'newArticleCategory/createNewArticleCategory',
      updateNewArticleCategoryStatus: 'newArticleCategory/updateNewArticleCategoryStatus'
    },
    newsArticle: {
      getNewsArticles: 'newsArticle/getNewsArticles',
      createNewsArticles: 'newsArticle/createNewsArticles',
      getNewsArticleById: 'newsArticle/getNewsArticleById?id=',
      getNewsArticleForClient: 'newsArticle/getNewsArticlesForClient',
      updateNewArticles: 'newsArticle/updateNewArticles',
      getNewsArticlesForClientById: 'newsArticle/getNewsArticlesForClientById'
    }
  }
  constructor() { }

}
